import { useEffect } from 'react'

/**
 * Mark the static splash (in `index.html`) as ready to fade out.
 *
 * Called from "terminal" pages (LoginPage, AppShell, ClubPickerPage) — i.e.
 * pages that render real content, not a loader. Loading-only states
 * (`<ProtectedRoute>` initial, `<ClubGate>` pending, `<Suspense>` fallback)
 * deliberately render `null` so the static splash keeps showing instead of
 * flashing a bare React shell for a single frame.
 *
 * Pass `ready` to defer (e.g. ClubPickerPage waits for the clubs query to
 * settle before showing real content).
 */
export function useAppReady(ready: boolean = true): void {
  useEffect(() => {
    if (!ready) return
    if (typeof document === 'undefined') return
    document.body.classList.add('app-ready')
  }, [ready])
}
